/* Nélya Paris (version paiement à la livraison) — fonctions pures (teinte, prix, quantité, galerie, lots, commande COD). Testées par tests/nelya-core.test.mjs. */
(function (root) {
  'use strict';

  var TEINTES = ['Brun', 'Gris'];
  var DEFAULT_TEINTE = 'Gris';

  function normalizeTeinte(v) {
    if (typeof v !== 'string') return null;
    var s = v.trim().toLowerCase();
    for (var i = 0; i < TEINTES.length; i++) if (TEINTES[i].toLowerCase() === s) return TEINTES[i];
    return null;
  }

  function variantForTeinte(variants, teinte) {
    for (var i = 0; i < (variants || []).length; i++) if (variants[i].option1 === teinte) return variants[i];
    return null;
  }

  /* La variante de l'URL (?variant=) prime ; sinon la teinte par défaut, Gris. */
  function initialTeinte(opts) {
    var id = opts && opts.variantId;
    var variants = (opts && opts.variants) || [];
    for (var i = 0; id && i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return normalizeTeinte(variants[i].option1) || DEFAULT_TEINTE;
    }
    return (opts && opts.fallback) || DEFAULT_TEINTE;
  }

  /* « … | Brun » ou « … | Gris » : média de cette teinte ; tout autre alt reste commun et intact. */
  function stripShadeSuffix(alt) {
    var m = /^(.*?)\s*\|\s*(Brun|Gris)\s*$/.exec(alt || '');
    return m ? { alt: m[1], teinte: m[2] } : { alt: alt || '', teinte: null };
  }

  /* Prix au format monétaire de la boutique (money_format de Shopify, ex. « {{amount_with_comma_separator}} lei »),
     identique au filtre Liquid money. Sans format donné : celui de la page (window.nelyaShop.money). */
  function groupThousands(int, sep) {
    return String(int).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function formatMoney(cents, format) {
    var fmt = format || (root.nelyaShop && root.nelyaShop.money) || '{{amount_with_comma_separator}}';
    var n = Math.round(Number(cents) || 0);
    function amount(dec, thou, decimals) {
      var c = String(n % 100);
      var s = groupThousands(decimals ? Math.floor(n / 100) : Math.round(n / 100), thou);
      return decimals ? s + dec + (c.length < 2 ? '0' + c : c) : s;
    }
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return amount('.', ',', false);
        case 'amount_with_comma_separator': return amount(',', '.', true);
        case 'amount_no_decimals_with_comma_separator': return amount(',', '.', false);
        case 'amount_with_space_separator': return amount(',', ' ', true);
        case 'amount_no_decimals_with_space_separator': return amount(',', ' ', false);
        case 'amount_with_apostrophe_separator': return amount('.', "'", true);
        default: return amount('.', ',', true);
      }
    });
    return out.replace(/&nbsp;/g, '\u00a0').replace(/&amp;/g, '&').replace(/<[^>]*>/g, '');
  }

  function clampQty(n, min, max) {
    min = min === undefined ? 1 : min; max = max === undefined ? 10 : max;
    var q = parseInt(n, 10);
    if (isNaN(q)) q = Math.max(min, 1);
    return Math.max(min, Math.min(max, q));
  }

  function galleryIndex(scrollLeft, width, count) {
    if (!width || !count) return 0;
    return Math.max(0, Math.min(count - 1, Math.round(scrollLeft / width)));
  }

  /* Indices des diapositives à montrer : communes ('') et celles de la teinte choisie. */
  function visibleSlides(slideTeintes, teinte) {
    var out = [];
    for (var i = 0; i < slideTeintes.length; i++) if (!slideTeintes[i] || slideTeintes[i] === teinte) out.push(i);
    return out;
  }

  /* Lot : les teintes des qty premiers emplacements, regroupées par variante.
     null si une teinte manque ou est inconnue : rien n'est ajouté plutôt qu'un lot incomplet. */
  function lotItems(opts) {
    var slots = (opts.slots || []).slice(0, opts.qty);
    if (slots.length !== opts.qty) return null;
    var out = [], byId = {};
    for (var i = 0; i < slots.length; i++) {
      var v = variantForTeinte(opts.variants, normalizeTeinte(slots[i]));
      if (!v) return null;
      if (byId[v.id]) byId[v.id].quantity++;
      else { byId[v.id] = { id: v.id, quantity: 1 }; out.push(byId[v.id]); }
    }
    return out;
  }

  /* COD : vide le panier, puis y met exactement les articles du lot. Le panier ne contient ainsi que la commande en cours,
     que le formulaire de paiement à la livraison reprend. Si l'ajout échoue, l'ancien contenu est remis (pas de commande
     perdue en silence) et ok:false est renvoyé : rien n'est alors ouvert. */
  function codOrder(items, fetchImpl) {
    var f = fetchImpl || root.fetch.bind(root);
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var list = [].concat(items).map(function (it) { return { id: it.id, quantity: it.quantity }; });
    var before = [];
    function post(url, body) { return f(url, { method: 'POST', headers: headers, body: body ? JSON.stringify(body) : undefined }); }
    return f('/cart.js', { headers: headers })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; }, function () { return { items: [] }; })
      .then(function (cart) {
        before = (cart.items || []).map(function (it) {
          var line = { id: it.variant_id || it.id, quantity: it.quantity };
          if (it.properties && Object.keys(it.properties).length) line.properties = it.properties;
          return line;
        });
        return post('/cart/clear.js');
      })
      .then(function (r) {
        if (!r.ok) return { ok: false, status: r.status, step: 'clear' };
        return post('/cart/add.js', { items: list }).then(function (a) {
          if (a.ok) return { ok: true };
          var fail = { ok: false, status: a.status, step: 'add' };
          if (!before.length) return fail;
          return post('/cart/add.js', { items: before }).then(function () { return fail; }, function () { return fail; });
        });
      })
      .catch(function () { return { ok: false }; });
  }

  root.NelyaCore = {
    DEFAULT_TEINTE: DEFAULT_TEINTE,
    normalizeTeinte: normalizeTeinte,
    variantForTeinte: variantForTeinte,
    initialTeinte: initialTeinte,
    stripShadeSuffix: stripShadeSuffix,
    formatMoney: formatMoney,
    clampQty: clampQty,
    galleryIndex: galleryIndex,
    visibleSlides: visibleSlides,
    lotItems: lotItems,
    codOrder: codOrder
  };
})(typeof self !== 'undefined' ? self : this);
